import { PresentModalOptions } from './Types';

export const swipeableCssClass =
  '[&::part(content)]:h-auto [&::part(handle)]:w-16 [&::part(handle)]:h-[2px] [&::part(handle)]:top-md [&::part(content)]:py-md';

export const defaultSwipeableModalOptions: PresentModalOptions = {
  initialBreakpoint: 1,
  breakpoints: [0, 1],
  cssClass: swipeableCssClass,
};
